(function() {
  var ScrollHelper, Storage;

  Storage = App.loadClass('core::Storage');

  ScrollHelper = exports;

  ScrollHelper.make = function(table, options, with_dropdown, applypaddings) {
    var defaultOptions, footheight, headheight, opts, size;
    if (options == null) {
      options = {};
    }
    if (with_dropdown == null) {
      with_dropdown = true;
    }
    if (applypaddings == null) {
      applypaddings = true;
    }
    headheight = table.find('thead').length ? table.find('thead').outerHeight() : 0;
    footheight = table.find('tfoot').length ? table.find('tfoot').outerHeight() : 0;
    size = options.height - headheight - footheight;
    defaultOptions = {
      'sScrollY': size + 'px',
      'bDestroy': true,
      'bPaginate': false,
      'bFilter': false,
      'bInfo': false,
      'bSort': false
    };
    opts = $.extend(defaultOptions, options);
    if (table.hasClass('dataTable')) {
      return;
    }
    table.dataTable(opts);
    if (with_dropdown) {
      return ScrollHelper.fixDropdownMenus(table);
    }
  };

  ScrollHelper.fixDropdownMenus = function(table) {
    table.find('.dropdown-toggle').dropdown();
    return table.find('.dropdown-toggle').click(function(e) {
      var bottom_diff, offset, right_diff;
      offset = $(this).offset();
      offset.top += $(this).parents('div').height();
      bottom_diff = (offset.top + $(this).siblings('ul').outerHeight(true)) - $(document).height();
      if (bottom_diff > 0) {
        offset.top = offset.top - bottom_diff;
      }
      right_diff = (offset.left + $(this).siblings('ul').outerWidth(true)) - $(document).width();
      if (right_diff > 0) {
        offset.left = offset.left - $(this).siblings('ul').outerWidth(true) + $(this).outerWidth(true);
      }
      $(this).siblings('ul').css({
        position: 'fixed',
        top: offset.top + "px",
        left: offset.left + "px",
        width: ($(this).siblings('ul').outerWidth()) + "px"
      });
      $(this).dropdown();
      return e.stopPropagation();
    });
  };


  /* --------------------------------------------------------
      The following function:
          setSaveScroll/2
  
      exists to help solve an issue with scrolling tables in
      the sidebar. Whenever you do a data altering change
      such as deleting or renaming an item in the sidebar,
      the easiest way to reflect the change is to refresh the
      handler to re-list the items. This can be frustrating
      though, because it will reset the scrolling on the sidebar.
  
      setSaveScroll will try fetching an existing saved scroll
      position for the passed page, and then set the scrollTop
      on the table, and add a listener to update the stored
      value for retrieval later
  
      NOTE: the 'table' attribute may not be an actual table,
      it is just whatever element is actually technically
      scrollable
  --------------------------------------------------------
   */

  ScrollHelper.setSaveScroll = function(page, table) {
    var scrollPosition, scrollStorage;
    scrollStorage = App.storage.retrieve('handler_scrolling_position', new Storage());
    scrollPosition = scrollStorage.retrieve(page, 0);
    scrollStorage.empty();
    App.storage.store('handler_scrolling_position', scrollStorage);
    table.prop('scrollTop', scrollPosition);
    return table.off('scroll').on('scroll', function() {
      return App.storage.retrieve('handler_scrolling_position').store(page, $(this).prop('scrollTop'));
    });
  };

}).call(this);
